export const MAJOR_CATEGORY_ALLOWED_VALUES = [
    {
        "shortForm": "IB_B_SUIT_FS",
        "fullForm": "INFANT BOYS BABA SUIT FULL SLEEVE"
    },
    {
        "shortForm": "IB_BERMUDA",
        "fullForm": "INFANT BOYS BERMUDA"
    },
    {
        "shortForm": "IB_DNGR_SUIT",
        "fullForm": "INFANT BOYS DANGRI SUIT"
    },
    {
        "shortForm": "IB_DNGR_SUIT_FS",
        "fullForm": "INFANT BOYS DANGRI SUIT FULL SLEEVE"
    },
    {
        "shortForm": "IB_H_B_SUIT_HS",
        "fullForm": "INFANT BOYS HOSIERY BABA SUIT HALF SLEEVE"
    },
    {
        "shortForm": "IB_PYJAMA",
        "fullForm": "INFANT BOYS PYJAMA"
    },
    {
        "shortForm": "IB_TEES_FS",
        "fullForm": "INFANT BOYS TEES FULL SLEEVE"
    },
    {
        "shortForm": "IB_TEES_HS",
        "fullForm": "INFANT BOYS TEES HALF SLEEVE"
    },
    {
        "shortForm": "IBW_B_SUIT",
        "fullForm": "INFANT BOYS WINTER BABA SUIT"
    },
    {
        "shortForm": "IBW_PYJAMA",
        "fullForm": "INFANT BOYS WINTER PYJAMA"
    },
    {
        "shortForm": "IBW_T_SHIRT",
        "fullForm": "INFANT BOYS WINTER T SHIRT"
    },
    {
        "shortForm": "IBW_THRM_W",
        "fullForm": "INFANT BOYS WINTER THERMAL WEAR"
    },
    {
        "shortForm": "IG_DNGR_SUIT",
        "fullForm": "INFANT GIRLS DANGRI SUIT"
    },
    {
        "shortForm": "IG_FROCK_FS",
        "fullForm": "INFANT GIRLS FROCK FULL SLEEVE"
    },
    {
        "shortForm": "IG_FROCK_HSR",
        "fullForm": "INFANT GIRLS FROCK HOSIERY"
    },
    {
        "shortForm": "IG_HOT_PANT_ST",
        "fullForm": "INFANT GIRLS HOT PANT SET"
    },
    {
        "shortForm": "IG_ST",
        "fullForm": "INFANT GIRLS SET"
    },
    {
        "shortForm": "IG_ST_FS",
        "fullForm": "INFANT GIRLS SET FULL SLEEVE"
    },
    {
        "shortForm": "IG_TOP_FS",
        "fullForm": "INFANT GIRLS TOP FULL SLEEVE"
    },
    {
        "shortForm": "IG_TOP_HS",
        "fullForm": "INFANT GIRLS TOP HALF SLEEVE"
    },
    {
        "shortForm": "IGW_JKT_FS",
        "fullForm": "INFANT GIRLS WINTER FULL SLEEVE"
    },
    {
        "shortForm": "JB_B_SUIT_SL",
        "fullForm": "JUNIOR BOYS BABA SUIT SLEEVE LESS"
    },
    {
        "shortForm": "JB_B_SUIT_SL",
        "fullForm": "JUNIOR BOYS BABA SUIT SLEEVE LESS"
    },
    {
        "shortForm": "JB_B_SUIT_SL",
        "fullForm": "JUNIOR BOYS BABA SUIT SLEEVE LESS"
    },
    {
        "shortForm": "JB_B_SUIT_ST_HS",
        "fullForm": "JUNIOR BOYS BABA SUIT SET HALF SLEEVE"
    },
    {
        "shortForm": "JB_BRIEF",
        "fullForm": "JUNIOR BOYS BRIEF"
    },
    {
        "shortForm": "JB_CRG",
        "fullForm": "JUNIOR BOYS CARGO"
    },
    {
        "shortForm": "JB_H_B_SUIT_FS",
        "fullForm": "JUNIOR BOYS HOSIERY BABA SUIT FULL SLEEVE"
    },
    {
        "shortForm": "JB_H_B_SUIT_HS",
        "fullForm": "JUNIOR BOYS HOSIERY BABA SUIT HALF SLEEVE"
    },
    {
        "shortForm": "JB_H_B_SUIT_HS",
        "fullForm": "JUNIOR BOYS HOSIERY BABA SUIT HALF SLEEVE"
    },
    {
        "shortForm": "JB_H_BERMUDA",
        "fullForm": "JUNIOR BOYS HOSIERY BERMUDA"
    },
    {
        "shortForm": "JB_H_PYJAMA",
        "fullForm": "JUNIOR BOYS HOSIERY PYJAMA"
    },
    {
        "shortForm": "JB_JEANS",
        "fullForm": "JUNIOR BOYS JEANS"
    },
    {
        "shortForm": "JB_K_SHIRT_HS",
        "fullForm": "JUNIOR BOYS KNIT SHIRT HALF SLEEVE"
    },
    {
        "shortForm": "JB_KURTA_ST",
        "fullForm": "JUNIOR BOYS KURTA SET"
    },
    {
        "shortForm": "JB_SHIRT_FS",
        "fullForm": "JUNIOR BOYS SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "JB_SHIRT_HS",
        "fullForm": "JUNIOR BOYS SHIRT HALF SLEEVE"
    },
    {
        "shortForm": "JB_SUIT",
        "fullForm": "JUNIOR BOYS SUIT"
    },
    {
        "shortForm": "JB_T_B_SUIT_FS",
        "fullForm": "JUNIOR BOYS TEXTILE BABA SUIT FULL SLEEVE"
    },
    {
        "shortForm": "JB_T_B_SUIT_HS",
        "fullForm": "JUNIOR BOYS TEXTILE BABA SUIT HALF SLEEVE"
    },
    {
        "shortForm": "JB_T_BERMUDA",
        "fullForm": "JUNIOR BOYS TEXTILE BERMUDA"
    },
    {
        "shortForm": "JB_T_JAMAICAN",
        "fullForm": "JUNIOR BOYS TEXTILE JAMAICAN"
    },
    {
        "shortForm": "JB_T_PYJAMA",
        "fullForm": "JUNIOR BOYS TEXTILE PYJAMA"
    },
    {
        "shortForm": "JB_T_SHIRT_PN_HS",
        "fullForm": "JUNIOR BOYS TEXTILE SHIRT POLO NECK HALF SLEEVE"
    },
    {
        "shortForm": "JB_TEES_FS",
        "fullForm": "JUNIOR BOYS TEES FULL SLEEVE"
    },
    {
        "shortForm": "JB_TEES_HD_FS",
        "fullForm": "JUNIOR BOYS TEES HD FULL SLEEVE"
    },
    {
        "shortForm": "JB_TEES_HS",
        "fullForm": "JUNIOR BOYS TEES HALF SLEEVE"
    },
    {
        "shortForm": "JB_TEES_SL",
        "fullForm": "JUNIOR BOYS TEES SLEEVE LESS"
    },
    {
        "shortForm": "JB_TRSR",
        "fullForm": "JUNIOR BOYS TROUSER"
    },
    {
        "shortForm": "JB_VEST",
        "fullForm": "JUNIOR BOYS VEST"
    },
    {
        "shortForm": "JBW_B_SUIT",
        "fullForm": "JUNIOR BOYS WINTER BABA SUIT"
    },
    {
        "shortForm": "JBW_JKT_FS",
        "fullForm": "JUNIOR BOYS WINTER JACKET FULL SLEEVE"
    },
    {
        "shortForm": "JBW_JKT_SL",
        "fullForm": "JUNIOR BOYS WINTER JACKET SLEEVE LESS"
    },
    {
        "shortForm": "JBW_PYJAMA",
        "fullForm": "JUNIOR BOYS WINTER PYJAMA"
    },
    {
        "shortForm": "JBW_SWEATER_FS",
        "fullForm": "JUNIOR BOYS WINTER SWEATER FULL SLEEVE"
    },
    {
        "shortForm": "JBW_T_SHIRT_FS",
        "fullForm": "JUNIOR BOYS WINTER T SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "JBW_T_SHIRT_HD_FS",
        "fullForm": "JUNIOR BOYS WINTER T SHIRT HOOD FULL SLEEVE"
    },
    {
        "shortForm": "JBW_T_SUIT",
        "fullForm": "JUNIOR BOYS WINTER TEXTILE SUIT"
    },
    {
        "shortForm": "JBW_THRM_W",
        "fullForm": "JUNIOR BOYS WINTER THERMAL WAER"
    },
    {
        "shortForm": "JBW_WNDCHTR",
        "fullForm": "JUNIOR BOYS WINTER WINDCHEATER"
    },
    {
        "shortForm": "JG_BLOOMER",
        "fullForm": "JUNIOR GIRLS BLOOMER"
    },
    {
        "shortForm": "JG_CARGO",
        "fullForm": "JUNIOR GIRLS CARGO"
    },
    {
        "shortForm": "JG_D_HOT_PANT",
        "fullForm": "JUNIOR GIRLS DENIM HOT PANT"
    },
    {
        "shortForm": "JG_H_FROCK",
        "fullForm": "JUNIOR GIRLS HOSIERY FROCK"
    },
    {
        "shortForm": "JG_H_HOT_PANT",
        "fullForm": "JUNIOR GIRLS HOSIERY HOT PANT"
    },
    {
        "shortForm": "JG_H_PYJAMA",
        "fullForm": "JUNIOR GIRLS HOSIERY PYJAMA"
    },
    {
        "shortForm": "JG_H_TOP_FS",
        "fullForm": "JUNIOR GIRLS HOSIERY TOP FULL SLEEVE"
    },
    {
        "shortForm": "JG_H_TOP_HS",
        "fullForm": "JUNIOR GIRLS HOSIERY TOP HALF SLEEVE"
    },
    {
        "shortForm": "JG_HOT_PANT_ST",
        "fullForm": "JUNIOR GIRLS HOT PANT SET"
    },
    {
        "shortForm": "JG_JEANS",
        "fullForm": "JUNIOR GIRLS JEANS"
    },
    {
        "shortForm": "JG_PANTY",
        "fullForm": "JUNIOR GIRLS PANTY"
    },
    {
        "shortForm": "JG_PW_FROCK",
        "fullForm": "JUNIOR GIRLS PW FROCK"
    },
    {
        "shortForm": "JG_SKRT_TOP_ST",
        "fullForm": "JUNIOR GIRLS SKRT TEXTILE TOP SET"
    },
    {
        "shortForm": "JG_SLIPS",
        "fullForm": "JUNIOR GIRLS SLIPS"
    },
    {
        "shortForm": "JG_ST",
        "fullForm": "JUNIOR GIRLS ST"
    },
    {
        "shortForm": "JG_ST_FS",
        "fullForm": "JUNIOR GIRLS SET FULL SLEEVE"
    },
    {
        "shortForm": "JG_T_FROCK",
        "fullForm": "JUNIOR GIRLS TEXTILE FROCK"
    },
    {
        "shortForm": "JG_T_HOT_PANT",
        "fullForm": "JUNIOR GIRLS TEXTILE HOT PANT"
    },
    {
        "shortForm": "JG_T_M_FROCK_HS",
        "fullForm": "JUNIOR GIRLS TEXTILE MID FROCK HALF SLEEVE"
    },
    {
        "shortForm": "JG_T_PYJAMA",
        "fullForm": "JUNIOR GIRLS TEXTILE PYJAMA"
    },
    {
        "shortForm": "JG_T_SKRT",
        "fullForm": "JUNIOR GIRLS TEXTILE SKIRT"
    },
    {
        "shortForm": "JG_T_TOP_FS",
        "fullForm": "JUNIOR GIRLS TEXTILE TOP FULL SLEEVE"
    },
    {
        "shortForm": "JG_T_TOP_HS",
        "fullForm": "JUNIOR GIRLS TEXTILE TOP HALF SLEEVE"
    },
    {
        "shortForm": "JGW_BLAZER",
        "fullForm": "JUNIOR GIRLS WINTER BLAZER"
    },
    {
        "shortForm": "JGW_FLC_TOP",
        "fullForm": "JUNIOR GIRLS WINTER FLEECE TOP"
    },
    {
        "shortForm": "JGW_JKT_FS",
        "fullForm": "JUNIOR GIRLS WINTER JACKET FULL SLEEVE"
    },
    {
        "shortForm": "JGW_LEGGING",
        "fullForm": "JUNIOR GIRLS WINTER LEGGING"
    },
    {
        "shortForm": "JGW_PYJAMA",
        "fullForm": "JUNIOR GIRLS WINTER PYJAMA"
    },
    {
        "shortForm": "JGW_SKEEVY",
        "fullForm": "JUNIOR GIRLS WINTER SKEEVY"
    },
    {
        "shortForm": "JGW_ST",
        "fullForm": "JUNIOR GIRLS WINTER SET"
    },
    {
        "shortForm": "JGW_THRM_W",
        "fullForm": "JUNIOR GIRLS WINTER THERMAL WEAR"
    },
    {
        "shortForm": "JGW_TOP",
        "fullForm": "JUNIOR GIRLS WINTER TOP"
    },
    {
        "shortForm": "JGW_W_PONCHO",
        "fullForm": "JUNIOR GIRLS WINTER WOVEN PONCHO"
    },
    {
        "shortForm": "KBW_CAP",
        "fullForm": "KIDS BOYS WINTER CAP"
    },
    {
        "shortForm": "KBW_EAR_BAND",
        "fullForm": "KIDS BOYS WINTER EAR BAND"
    },
    {
        "shortForm": "KBW_GLOVES",
        "fullForm": "KIDS BOYS WINTER GLOVES"
    },
    {
        "shortForm": "KGW_CAP",
        "fullForm": "KIDS GIRLS WINTER CAP"
    },
    {
        "shortForm": "KGW_EAR_BAND",
        "fullForm": "KIDS GIRLS WINTER EAR BAND"
    },
    {
        "shortForm": "KGW_GLOVES",
        "fullForm": "KIDS GIRLS WINTER GLOVES"
    },
    {
        "shortForm": "KI_B_SUIT_SL",
        "fullForm": "KIDS INFANT BABA SUIT SLEEVE LESS"
    },
    {
        "shortForm": "KI_B_SUIT_ST_HS",
        "fullForm": "KIDS INFANT BABA SUIT SET HALF SLEEVE"
    },
    {
        "shortForm": "KI_BIB",
        "fullForm": "KIDS INFANT BIB"
    },
    {
        "shortForm": "KI_BLOOMER",
        "fullForm": "KIDS INFANT BLOOMER"
    },
    {
        "shortForm": "KI_BOOTY",
        "fullForm": "KIDS INFANT BOOTY"
    },
    {
        "shortForm": "KI_FEEDING_BOTTLE",
        "fullForm": "KIDS INFANT FEEDING BOTTLE"
    },
    {
        "shortForm": "KI_PILLOW",
        "fullForm": "KIDS INFANT PILLOW"
    },
    {
        "shortForm": "KI_SIPPER",
        "fullForm": "KIDS INFANT SIPPER"
    },
    {
        "shortForm": "KI_SKRT_TOP_ST",
        "fullForm": "KIDS INFANT SKIRT TOP SET"
    },
    {
        "shortForm": "KI_TOWEL",
        "fullForm": "KIDS INFANT TOWEL"
    },
    {
        "shortForm": "KIW_BLANKET",
        "fullForm": "KIDS INFANT WINTER BLANKET"
    },
    {
        "shortForm": "KIW_BOOTY",
        "fullForm": "KIDS INFANT WINTER BOOTY"
    },
    {
        "shortForm": "KIW_CAP",
        "fullForm": "KIDS INFANT WINTER CAP"
    },
    {
        "shortForm": "KIW_GIFT_ST",
        "fullForm": "KIDS INFANT WINTER GIFT SET"
    },
    {
        "shortForm": "KIW_GLOVES",
        "fullForm": "KIDS INFANT WINTER GLOVES"
    },
    {
        "shortForm": "KIW_JKT_SL",
        "fullForm": "KIDS INFANT WINTER JACKET SLEEVE LESS"
    },
    {
        "shortForm": "KIW_ST",
        "fullForm": "KIDS INFANT WINTER SET"
    },
    {
        "shortForm": "KIW_TOP",
        "fullForm": "KIDS INFANT WINTER TOP"
    },
    {
        "shortForm": "L_BLAZER_MW",
        "fullForm": "LADIES BLAZER MW"
    },
    {
        "shortForm": "L_BRA",
        "fullForm": "LADIES BRA"
    },
    {
        "shortForm": "L_CARGO",
        "fullForm": "LADIES CARGO"
    },
    {
        "shortForm": "L_CIG_PANT",
        "fullForm": "LADIES CIGARETTE PANT"
    },
    {
        "shortForm": "L_CULOTTES",
        "fullForm": "LADIES CULOTTES"
    },
    {
        "shortForm": "L_D_JOGGER",
        "fullForm": "LADIES DENIM JOGGER"
    },
    {
        "shortForm": "L_DUPATTA",
        "fullForm": "LADIES DUPATTA"
    },
    {
        "shortForm": "L_H_CAPRI",
        "fullForm": "LADIES HOSIERY CAPRI"
    },
    {
        "shortForm": "L_H_CROP_TOP_FS",
        "fullForm": "LADIES HOSIERY CROP TOP FULL SLEEVE"
    },
    {
        "shortForm": "L_H_CROP_TOP_HS",
        "fullForm": "LADIES HOSIERY CROP TOP HALF SLEEVE"
    },
    {
        "shortForm": "L_H_HOT_PANT",
        "fullForm": "LADIES HOSIERY HOT PANT"
    },
    {
        "shortForm": "L_H_NIGHTY",
        "fullForm": "LADIES HOSIERY NIGHTY"
    },
    {
        "shortForm": "L_H_PYJAMA",
        "fullForm": "LADIES HOSIERY PYJAMA"
    },
    {
        "shortForm": "L_H_TOP_FS",
        "fullForm": "LADIES HOSIERY TOP FULL SLEEVE"
    },
    {
        "shortForm": "L_H_TOP_HS",
        "fullForm": "LADIES HOSIERY TOP HALF SLEEVE"
    },
    {
        "shortForm": "L_HAREMS",
        "fullForm": "LADIES HAREMS"
    },
    {
        "shortForm": "L_JEANS",
        "fullForm": "LADIES JEANS"
    },
    {
        "shortForm": "L_KURTI_FS",
        "fullForm": "LADIES KURTI FULL SLEEVE"
    },
    {
        "shortForm": "L_KURTI_HS",
        "fullForm": "LADIES KURTI HALF SLEEVE"
    },
    {
        "shortForm": "L_KURTI_ST",
        "fullForm": "LADIES KURTI SET"
    },
    {
        "shortForm": "L_LEGGING",
        "fullForm": "LADIES LEGGING"
    },
    {
        "shortForm": "L_N_SUIT",
        "fullForm": "LADIES NIGHT SUIT"
    },
    {
        "shortForm": "L_PANTY",
        "fullForm": "LADIES PANTY"
    },
    {
        "shortForm": "L_PLAZO",
        "fullForm": "LADIES PLAZO"
    },
    {
        "shortForm": "L_SCARF",
        "fullForm": "LADIES SCARF"
    },
    {
        "shortForm": "L_SHIRTS",
        "fullForm": "LADIES SHIRTS"
    },
    {
        "shortForm": "L_SLIPS",
        "fullForm": "LADIES SLIPS"
    },
    {
        "shortForm": "L_SPRT_BRA",
        "fullForm": "LADIES SPORTS BRA"
    },
    {
        "shortForm": "L_T_HOT_PANT",
        "fullForm": "LADIES TEXTILE HOT PANT"
    },
    {
        "shortForm": "L_T_M_FRK_FS",
        "fullForm": "LADIES TEXTILE MID FROCK FULL SLEEVE"
    },
    {
        "shortForm": "L_T_M_FRK_HS",
        "fullForm": "LADIES TEXTILE MID FROCK HALF SLEEVE"
    },
    {
        "shortForm": "L_T_NIGHTY",
        "fullForm": "LADIES TEXTILE NIGHTY"
    },
    {
        "shortForm": "L_T_PYJAMA",
        "fullForm": "LADIES TEXTILE PYJAMA"
    },
    {
        "shortForm": "L_T_TOP_FS",
        "fullForm": "LADIES TEXTILE TOP FULL SLEEVE"
    },
    {
        "shortForm": "L_T_TOP_HS",
        "fullForm": "LADIES TEXTILE TOP HALF SLEEVE"
    },
    {
        "shortForm": "LW_BLAZER",
        "fullForm": "LADIES WINTER BLAZER"
    },
    {
        "shortForm": "LW_BLAZER_WLN",
        "fullForm": "LADIES WINTER BLAZER WOOLEN"
    },
    {
        "shortForm": "LW_CAP",
        "fullForm": "LADIES WINTER CAP"
    },
    {
        "shortForm": "LW_CO_ORD_SET",
        "fullForm": "LADIES WINTER CO ORD SET"
    },
    {
        "shortForm": "LW_EAR_BAND",
        "fullForm": "LADIES WINTER EAR BAND"
    },
    {
        "shortForm": "LW_FLC_TOP",
        "fullForm": "LADIES WINTER FLEECE TOP"
    },
    {
        "shortForm": "LW_GLOVES",
        "fullForm": "LADIES WINTER GLOVES"
    },
    {
        "shortForm": "LW_HW_JKT_FS",
        "fullForm": "LADIES WINTER HEAVY WEIHT JACKET FULL SLEEVE"
    },
    {
        "shortForm": "LW_JKT_SL",
        "fullForm": "LIGHT WEIGHT JACKET SLEEVE LESS"
    },
    {
        "shortForm": "LW_KURTI",
        "fullForm": "LADIES WINTER KURTI"
    },
    {
        "shortForm": "LW_KURTI_ST",
        "fullForm": "LADIES WINTER KURTI SET"
    },
    {
        "shortForm": "LW_LEGGING",
        "fullForm": "LADIES WINTER LEGGING"
    },
    {
        "shortForm": "LW_LTW_JKT_FS",
        "fullForm": "LADIES WINTER LIGHT WEIGHT JACKET FULL SLEEVE"
    },
    {
        "shortForm": "LW_NIGHT_SUIT",
        "fullForm": "LADIES WINTER NIGHT SUIT"
    },
    {
        "shortForm": "LW_PLAZO",
        "fullForm": "LADIES WINTER PLAZO"
    },
    {
        "shortForm": "LW_PYJAMA",
        "fullForm": "LADIES WINTER PYJAMA"
    },
    {
        "shortForm": "LW_SHAWL",
        "fullForm": "LADIES WINTER SHAWL"
    },
    {
        "shortForm": "LW_SKEEVY",
        "fullForm": "LADIES WINTER SKEEVY"
    },
    {
        "shortForm": "LW_STOLE",
        "fullForm": "LADIES WINTER STOLE"
    },
    {
        "shortForm": "LW_SWEATER_FS",
        "fullForm": "LADIES WINTER SWEATER FULL SLEEVE"
    },
    {
        "shortForm": "LW_SWEATER_SL",
        "fullForm": "LADIES WINTER SWEATER SLEEVE LESS"
    },
    {
        "shortForm": "LW_THRM_LOWER",
        "fullForm": "LADIES WINTER THERMAL LOWER"
    },
    {
        "shortForm": "LW_THRM_UPPER",
        "fullForm": "LADIES WINTER THERMAL UPPER"
    },
    {
        "shortForm": "LW_TOP",
        "fullForm": "LADIES WINTER TOP"
    },
    {
        "shortForm": "LW_WNDCHTR_JKT_FS",
        "fullForm": "LADIES WINTER WNDCHTR JACKET FULL SLEEVE"
    },
    {
        "shortForm": "M_BOXER",
        "fullForm": "MENS BOXER"
    },
    {
        "shortForm": "M_BRIEF",
        "fullForm": "MENS BRIEF"
    },
    {
        "shortForm": "M_CARGO",
        "fullForm": "MENS CARGO"
    },
    {
        "shortForm": "M_F_SHIRT_FS",
        "fullForm": "MENS FORMAL SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "M_F_TRSR",
        "fullForm": "MENS FORMAL TROUSER"
    },
    {
        "shortForm": "M_HOLI",
        "fullForm": "MENS HOLI"
    },
    {
        "shortForm": "M_JEANS",
        "fullForm": "MENS JEANS"
    },
    {
        "shortForm": "M_K_BERMUDA",
        "fullForm": "MENS KNIT BERMUDA"
    },
    {
        "shortForm": "M_K_PYJAMA",
        "fullForm": "MENS KNITTED PYJAMA"
    },
    {
        "shortForm": "M_K_SHIRT_HS",
        "fullForm": "MENS KNIT SHIRT HALF SLEEVE"
    },
    {
        "shortForm": "M_K_TRSR",
        "fullForm": "MENS KNIT TROUSER"
    },
    {
        "shortForm": "M_KURTA_FS",
        "fullForm": "MENS KURTA FULL SLEEVE"
    },
    {
        "shortForm": "M_KURTA_HS",
        "fullForm": "MENS KURTA HALF SLEEVE"
    },
    {
        "shortForm": "M_MODI_JKT",
        "fullForm": "MENS MODI JACKET"
    },
    {
        "shortForm": "M_PRW_SHIRT_FS",
        "fullForm": "MENS PRE-WINTER SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "M_PW_SHIRT_FS",
        "fullForm": "MENS PRE WINTER SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "M_SANDO",
        "fullForm": "MENS SANDO"
    },
    {
        "shortForm": "M_SF_SHIRT_FS",
        "fullForm": "MENS SEMIFORMAL SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "M_SUIT",
        "fullForm": "MENS SUIT"
    },
    {
        "shortForm": "M_TEES_FS",
        "fullForm": "MENS TEES FULL SLEEVE"
    },
    {
        "shortForm": "M_TEES_HS",
        "fullForm": "MENS TEES HALF SLEEVE"
    },
    {
        "shortForm": "M_TEES_PN_HS",
        "fullForm": "MENS TEES POLO NECK HALF SLEEVE"
    },
    {
        "shortForm": "M_TEES_SL",
        "fullForm": "MENS TEES SLEEVE LESS"
    },
    {
        "shortForm": "M_TIGHTS_FS",
        "fullForm": "MENS TIGHTS FULL SLEEVE"
    },
    {
        "shortForm": "M_TIGHTS_HS",
        "fullForm": "MENS TIGHTS HALF SLEEVE"
    },
    {
        "shortForm": "M_VEST",
        "fullForm": "MENS VEST"
    },
    {
        "shortForm": "M_W_BERMUDA",
        "fullForm": "MENS WOVEN BERMUDA"
    },
    {
        "shortForm": "M_W_JAMAICAN",
        "fullForm": "MENS WOVEN JAMAICAN"
    },
    {
        "shortForm": "M_W_PYJAMA",
        "fullForm": "MENS WOVEN PYJAMA"
    },
    {
        "shortForm": "M_W_SHIRT_FS",
        "fullForm": "MENS WOVEN SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "M_W_SHIRT_HS",
        "fullForm": "MENS WOVEN SHIRT HALF SLEEVE"
    },
    {
        "shortForm": "M_W_TRSR",
        "fullForm": "MENS WOVEN TROUSER"
    },
    {
        "shortForm": "MW_BLAZER",
        "fullForm": "MENS WINTER BLAZER"
    },
    {
        "shortForm": "MW_CAP",
        "fullForm": "MENS WINTER CAP"
    },
    {
        "shortForm": "MW_EAR_CAP",
        "fullForm": "MENS WINTER EAR CAP"
    },
    {
        "shortForm": "MW_GLOVES",
        "fullForm": "MENS WINTER GLOVES"
    },
    {
        "shortForm": "MW_HRY_SWTR_FS",
        "fullForm": "MENS WINTER HRY SWTR FULL SLEEVE"
    },
    {
        "shortForm": "MW_HW_JKT_FS",
        "fullForm": "MENS WINTER HAVY WEIGHT JACKET FULL SLEEVE"
    },
    {
        "shortForm": "MW_JKT_SL",
        "fullForm": "MENS WINTER JACKET SLEEVE LESS"
    },
    {
        "shortForm": "MW_LW_JKT_FS",
        "fullForm": "MENS WINTER LIGHT WEIGHT JACKET FULL SLEEVE"
    },
    {
        "shortForm": "MW_MODI_JKT",
        "fullForm": "MENS WINTER MODI JACKET"
    },
    {
        "shortForm": "MW_MUFFLER",
        "fullForm": "MENS WINTER MUFFLER"
    },
    {
        "shortForm": "MW_PYJAMA",
        "fullForm": "MENS WINTER PYJAMA"
    },
    {
        "shortForm": "MW_SHACKET",
        "fullForm": "MENS WINTER SHACKET"
    },
    {
        "shortForm": "MW_SWEATER_SL",
        "fullForm": "MENS WINTER SWEATER SLEEVE LESS"
    },
    {
        "shortForm": "MW_SWTR_FS",
        "fullForm": "MENS WINTER SWEATER FULL SLEEVE"
    },
    {
        "shortForm": "MW_TEES_FS",
        "fullForm": "MENS WINTER TEES FULL SLEEVE"
    },
    {
        "shortForm": "MW_TEES_HUD_FS",
        "fullForm": "MENS WINTER TEES HUD FULL SLEEVE"
    },
    {
        "shortForm": "MW_TEES_SL",
        "fullForm": "MENS WINTER TEES SLEEVE LESS"
    },
    {
        "shortForm": "MW_THRM_LOWER",
        "fullForm": "MENS WINTER THERMAL LOWER"
    },
    {
        "shortForm": "MW_THRM_UPPER",
        "fullForm": "MENS WINTER THERMAL UPPER"
    },
    {
        "shortForm": "MW_TRACK_SUIT",
        "fullForm": "MENS WINTER TRACK SUIT"
    },
    {
        "shortForm": "MW_WNDCHTR_JKT_FS",
        "fullForm": "MENS WINTER WINDCHEATER JACKET FULL SLEEVE"
    },
    {
        "shortForm": "YB_BRIEF",
        "fullForm": "YOUNGER BOYS BRIEF"
    },
    {
        "shortForm": "YB_CRG",
        "fullForm": "YOUNGER BOYS CARGO"
    },
    {
        "shortForm": "YB_H_B_SUIT_HS",
        "fullForm": "YOUNGER BOYS HOSIERY BABA SUIT HALF SLEEVE"
    },
    {
        "shortForm": "YB_H_BERMUDA",
        "fullForm": "YOUNGER BOYS HOSIERY BERMUDA"
    },
    {
        "shortForm": "YB_H_PYJAMA",
        "fullForm": "YOUNGER BOYS HOSIERY PYJAMA"
    },
    {
        "shortForm": "YB_JEANS",
        "fullForm": "YOUNGER BOYS JEANS"
    },
    {
        "shortForm": "YB_K_SHIRT_HS",
        "fullForm": "YOUNGER BOYS KNIT SHIRT HALF SLEEVE"
    },
    {
        "shortForm": "YB_KURTA_ST",
        "fullForm": "YOUNGER BOYS KURTA SET"
    },
    {
        "shortForm": "YB_SHIRT_FS",
        "fullForm": "YOUNGER BOYS SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "YB_SHIRT_HS",
        "fullForm": "YOUNGER BOYS SHIRT HALF SLEEVE"
    },
    {
        "shortForm": "YB_SUIT",
        "fullForm": "YOUNGER BOYS SUIT"
    },
    {
        "shortForm": "YB_T_BERMUDA",
        "fullForm": "YOUNGER BOYS TEXTILE BERMUDA"
    },
    {
        "shortForm": "YB_T_JAMAICAN",
        "fullForm": "YOUNGER BOYS TEXTILE JAMAICAN"
    },
    {
        "shortForm": "YB_T_PYJAMA",
        "fullForm": "YOUNGER BOYS TEXTILE PYJAMA"
    },
    {
        "shortForm": "YB_T_SHIRT_PN_HS",
        "fullForm": "YOUNGER BOYS TEXTILE SHIRT POLO NECK HALF SLEEVE"
    },
    {
        "shortForm": "YB_TEES_FS",
        "fullForm": "YOUNGER BOYS TEES FULL SLEEVE"
    },
    {
        "shortForm": "YB_TEES_HD_FS",
        "fullForm": "YOUNGER BOYS TEES HOOD FULL SLEEVE"
    },
    {
        "shortForm": "YB_TEES_HS",
        "fullForm": "YOUNGER BOYS TEES HALF SLEEVE"
    },
    {
        "shortForm": "YB_TEES_SL",
        "fullForm": "YOUNGER BOYS TEES SLEEVE LESS"
    },
    {
        "shortForm": "YB_TRSR",
        "fullForm": "YOUNGER BOYS TROUSER"
    },
    {
        "shortForm": "YBW_JKT_FS",
        "fullForm": "YOUNGER BOYS WINTER JACKET FULL SLEEVE"
    },
    {
        "shortForm": "YBW_JKT_SL",
        "fullForm": "YOUNGER BOYS WINTER JACKET SLEEVE LESS"
    },
    {
        "shortForm": "YBW_PYJAMA",
        "fullForm": "YOUNGER BOYS WINTER PYJAMA"
    },
    {
        "shortForm": "YBW_SWEATER_FS",
        "fullForm": "YOUNGER BOYS WINTER SWEATER FULL SLEEVE"
    },
    {
        "shortForm": "YBW_T_SHIRT_FS",
        "fullForm": "YOUNGER BOYS WINTER T SHIRT FULL SLEEVE"
    },
    {
        "shortForm": "YBW_T_SHIRT_HD_FS",
        "fullForm": "YOUNGER BOYS WINTER T SHIRT HOOD FULL SLEEVE"
    },
    {
        "shortForm": "YBW_T_SUIT",
        "fullForm": "YOUNGER BOYS WINTER TEXTILE SUIT"
    },
    {
        "shortForm": "YBW_THRM_W",
        "fullForm": "YOUNGER BOYS WINTER THERMAL WEAR"
    },
    {
        "shortForm": "YBW_WNDCHTR",
        "fullForm": "YOUNGER BOYS WINTER WINDCHEATER"
    },
    {
        "shortForm": "YG_CARGO",
        "fullForm": "YOUNGER GIRLS CARGO"
    },
    {
        "shortForm": "YG_D_HOT_PANT",
        "fullForm": "YOUNGER GIRLS DENIM HOT PANT"
    },
    {
        "shortForm": "YG_H_FROCK",
        "fullForm": "YOUNGER GIRLS HOSIERY FROCK"
    },
    {
        "shortForm": "YG_H_HOT_PANT",
        "fullForm": "YOUNGER GIRLS HOSIERY HOT PANT"
    },
    {
        "shortForm": "YG_H_PYJAMA",
        "fullForm": "YOUNGER GIRLS HOSIERY PYJAMA"
    },
    {
        "shortForm": "YG_H_TOP_FS",
        "fullForm": "YOUNGER GIRLS HOSIERY TOP FULL SLEEVE"
    },
    {
        "shortForm": "YG_H_TOP_HS",
        "fullForm": "YOUNGER GIRLS HOSIERY TOP HALF SLEEVE"
    },
    {
        "shortForm": "YG_JEANS",
        "fullForm": "YOUNGER GIRLS JEANS"
    },
    {
        "shortForm": "YG_PANTY",
        "fullForm": "YOUNGER GIRLS PANTY"
    },
    {
        "shortForm": "YG_PW_FROCK",
        "fullForm": "YOUNGER GIRLS PRE WINTER FROCK"
    },
    {
        "shortForm": "YG_SLIPS",
        "fullForm": "YOUNGER GIRLS SLIPS"
    },
    {
        "shortForm": "YG_ST",
        "fullForm": "YOUNGER GIRLS SET"
    },
    {
        "shortForm": "YG_ST_FS",
        "fullForm": "YOUNGER GIRLS SET FULL SLEEVE"
    },
    {
        "shortForm": "YG_T_FROCK",
        "fullForm": "YOUNGER GIRLS TEXTILE FROCK"
    },
    {
        "shortForm": "YG_T_HOT_PANT",
        "fullForm": "YOUNGER GIRLS TEXTILE HOT PANT"
    },
    {
        "shortForm": "YG_T_M_FROCK_HS",
        "fullForm": "YOUNGER GIRLS TEXTILE MID FROCK HALF SLEEVE"
    },
    {
        "shortForm": "YG_T_PYJAMA",
        "fullForm": "YOUNGER GIRLS TEXTILE PYJAMA"
    },
    {
        "shortForm": "YG_T_SKRT",
        "fullForm": "YOUNGER GIRLS TEXTIL SKIRT"
    },
    {
        "shortForm": "YG_T_TOP_FS",
        "fullForm": "YOUNGER GIRLS TEXTILE TOP FULL SLEEVE"
    },
    {
        "shortForm": "YG_T_TOP_HS",
        "fullForm": "YOUNGER GIRLS TEXTILE TOP HALF SLEEVE"
    },
    {
        "shortForm": "YGW_BLAZER",
        "fullForm": "YOUNGER GIRLS WINTER BLAZER"
    },
    {
        "shortForm": "YGW_FLC_TOP",
        "fullForm": "YOUNGER GIRLS WINTER FLEECE TOP"
    },
    {
        "shortForm": "YGW_JKT_FS",
        "fullForm": "YOUNGER GIRLS WINTER JACKET FULL SLEEVE"
    },
    {
        "shortForm": "YGW_LEGGING",
        "fullForm": "YOUNGER GIRLS WINTER LEGGING"
    },
    {
        "shortForm": "YGW_PYJAMA",
        "fullForm": "YOUNGER GIRLS WINTER PYJAMA"
    },
    {
        "shortForm": "YGW_SKEEVY",
        "fullForm": "YOUNGER GIRLS WINTER SKEEVY"
    },
    {
        "shortForm": "YGW_THRM_W",
        "fullForm": "YOUNGER GIRLS WINTER THERMAL WEAR"
    },
    {
        "shortForm": "YGW_TOP",
        "fullForm": "YOUNGER GIRLS WINTER TOP"
    }
];